/**
 * 【TKG_RESERVE_0130】イベント詳細画面
 * イベント詳細画面全体を定義します
 */
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  useTheme,
  useMediaQuery
} from "@mui/material";

import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  WarningAmber as WarningAmberIcon,
  ArrowBack as ArrowBackIcon,
  Info as InfoIcon,
  Error as ErrorIcon
} from '@mui/icons-material';

import { OutletContextType } from '../root';
import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, useOutletContext } from 'react-router-dom';

import {
  getEventDetails,
  cancelApply,
  reserveApply,
  todayDrinkApply
} from '../../api/api';

import { ReserveStatus } from '../../api/unit/ReserveStatus';
import { DateTime } from '../../api/unit/DateTime';

import { EventInfo } from "./parts/eventInfo";
import { InputFormat } from "./parts/inputFormTable";
import { QuestionAnswer } from "./parts/questionAnswer";
import { PayCompleteConfirm } from "./parts/payCompleteCofirm";
import { FaqInformationBox } from "./parts/faqInformationBox";

import basketballImage from '../../img/basketball_header.png';
import otherImage from '../../img/other_header.png';

// ======================================
// この画面のパラメータ
// ======================================
var eventId = ''; // イベントID

// ======================================
// イベント詳細画面
// ======================================
export const EventScreen = () => {
  const [openApplyDialog, setOpenApplyDialog] = useState(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [openApplyConfirmDialog, setOpenApplyConfirmDialog] = useState(false);
  const [openApplyConfirmFailedDialog, setOpenApplyConfirmFailedDialog] = useState(false);
  const [openCancelConfirmDialog, setOpenCancelConfirmDialog] = useState(false);
  const [openCancelConfirmFailedDialog, setOpenCancelConfirmFailedDialog] = useState(false);
  const [opentodayApplyDialog, setOpentodayApplyDialog] = useState(false);
  const [isToday, setIsToday] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [eventInfo, setEventInfo] = useState<any>(null);
  const [inputValue, setInputValue] = useState<any>(null);
  const [questionValue, setQuestionValue] = useState<any>(null);
  const [cancelTarget, setCancelTarget] = useState('');
  const [isValidationError, setIsValidationError] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  const [processResultMessage, setProcessResultMessage] = useState<string>('');
  const [openResultDialog, setOpenResultDialog] = useState<boolean>(false);
  const [showCancelValidationMessage, setShowCancelValidationMessage] = useState<boolean>(false);
  const { userId } = useOutletContext<OutletContextType>();
  const navigate = useNavigate();

  // レスポンシブ対応
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // モバイル用のスタイル適用

  // 入力値の追跡オブジェクト
  const formRef = {
    reserveCls: useRef<string>(""),
    sex: useRef<string>(""),
    birthday: useRef<string>(""),
    paypayName: useRef<string>(""),
    paypayId: useRef<string>(""),
    questionAnswer: useRef<string>(""),
    message: useRef<string>(""),
    isPayComplete: useRef<boolean>(false)
  };

  // この画面に渡されたパラメータを取得する
  const location = useLocation();

  /**
   * 初期表示処理
   *
   * @param eventId イベントID
   */
  useEffect(() => {
    // パラメータを取得
    eventId = location.state.event_id;

    // ======================================
    // 表示する情報をサーバーサイドから取得
    // ======================================
    getEventDetails(userId, eventId).then(eventDetail => {
      const eventInfo = {
        eventName: eventDetail.eventName ? eventDetail.eventName : "-",
        eventDate: eventDetail.eventDate ? eventDetail.eventDate : "",
        b_eventTime: eventDetail.bStartTime ? [new DateTime(eventDetail.bStartTime).getHHmm(), new DateTime(eventDetail.bEndTime).getHHmm()] : null,
        d_eventTime: eventDetail.dStartTime ? [new DateTime(eventDetail.dStartTime).getHHmm(), new DateTime(eventDetail.dEndTime).getHHmm()] : null,
        b_entryFee: eventDetail.bEntryFee ? eventDetail.bEntryFee : "-",
        d_entryFee: eventDetail.dEntryFee ? eventDetail.dEntryFee : "-",
        arenaName: eventDetail.arenaName ? eventDetail.arenaName : "",
        arenaUrl: eventDetail.arenaUrl ? eventDetail.arenaUrl : "",
        restaurantName: eventDetail.restaurantName ? eventDetail.restaurantName : "",
        restarauntUrl: eventDetail.restarauntUrl ? eventDetail.restarauntUrl : "",
        meeting: [new DateTime(eventDetail.meetingTime).getHHmm(), eventDetail.meetingPlace ? eventDetail.meetingPlace : "集合場所未定"],
        participantsNum: eventDetail.participantsNum !== null ? eventDetail.participantsNum : "？",
        capacityNum: eventDetail.capacityNum ? eventDetail.capacityNum : "？",
        manParticipantsNum: eventDetail.manParticipantsNum !== null ? eventDetail.manParticipantsNum : 0,
        manCapacityNum: eventDetail.manCapacityNum ? eventDetail.manCapacityNum : 0,
        womanParticipantsNum: eventDetail.womanParticipantsNum !== null ? eventDetail.womanParticipantsNum : 0,
        womanCapacityNum: eventDetail.womanCapacityNum ? eventDetail.womanCapacityNum : 0,
        cancelWaitReserveNum: eventDetail.cancelWaitReserveNum ? eventDetail.cancelWaitReserveNum : 0,
        cancelWaitPotision: eventDetail.cancelWaitPotision ? eventDetail.cancelWaitPotision : -1,
        eventContent: eventDetail.eventContent ? eventDetail.eventContent : "",
        belongings: eventDetail.belongings ? eventDetail.belongings : "",
        facility: eventDetail.facility ? eventDetail.facility : "",
        notes: eventDetail.notes ? eventDetail.notes : "",
        isSoldOut: eventDetail.isSoldOut
      };

      const inputValue = {
        reserveStatus : new ReserveStatus(eventDetail.reserveStatus),
        reserveCls : String(),
        bParticipationFlag: eventDetail.bParticipationFlag,
        dParticipationFlag: eventDetail.dParticipationFlag,
        sex: eventDetail.sex,
        birthday: eventDetail.birthday,
        paypayName: eventDetail.paypayName,
        paypayId: eventDetail.paypayId,
        message: eventDetail.message,
        reserveType: eventDetail.bStartTime ? eventDetail.dStartTime ? "2" : "1" : eventDetail.dStartTime ? "3" : "0"
      };
      const questionValue = {
        questionContent: eventDetail.questionContent,
        questionAnswer: eventDetail.questionAnswer
      };

      // 予約済であれば、予約内容区分をセットする
      if (inputValue?.reserveStatus?.isReserved()) {
        if (eventDetail.bParticipationFlag === "1" && eventDetail.dParticipationFlag === "1") {
          inputValue.reserveCls = "2";
        } else if (eventDetail.bParticipationFlag === "1") {
          inputValue.reserveCls = "1";
        } else if (eventDetail.dParticipationFlag === "1") {
          inputValue.reserveCls = "3";
        }
      }

      // 本日開催であるかどうを判定
      setIsToday(eventDetail.bStartTime ? new DateTime(eventDetail.bStartTime).isToday() : (eventDetail.dStartTime ? new DateTime(eventDetail.dStartTime).isToday() : false));

      // 取得した情報を画面にセットする
      setEventInfo(eventInfo);
      setInputValue(inputValue);
      setQuestionValue(questionValue);
    })
  }, [userId, location.state.event_id]);

  // データが読み込めなかった場合、エラー文言を表示する
  if (location.state === null || !eventInfo || !inputValue) {
    return (
      <>
      {/* ローディングアイコン */}
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          color: '#fff',
          backgroundColor: '#f44336',
          paddingTop: isMobile ? '10vh': '15vh',
          padding: '10px',
          borderRadius: '5px',
        }}
      >
        <ErrorIcon sx={{ marginRight: '8px' }} />
        データが読み込めません。再読み込みしてください。
      </Typography>
      </>
    )
  }

  // ======================================
  // 「予約申請」関連処理
  // ======================================
  /**
   * 「予約申請」ボタン処理
   */
  const handleOnReserveClick = () => {
    let errorMessage = ``;

    // バリデーションチェック処理
    if ((userId === null || userId === "") || (eventId === null || eventId === "")) {
      errorMessage += `ユーザーIDまたはイベントIDが確認できません。イベント一覧画面からやり直してください。`;
      setIsValidationError(true);
    } else {
      if ((formRef.reserveCls.current === null || formRef.reserveCls.current === "") && (inputValue.reserveCls === null || inputValue.reserveCls === "")) {
        errorMessage += `予約内容を選択してください。\n`;
        setIsValidationError(true);
      }
      if ((formRef.birthday.current === null || formRef.birthday.current === "") && (inputValue.birthday === null || inputValue.birthday === "")) {
        errorMessage += `誕生日を入力してください。\n`;
        setIsValidationError(true);
      }
      if ((formRef.sex.current === null || formRef.sex.current === "") && (inputValue.sex === null || inputValue.sex === "")) {
        errorMessage += `性別を入力してください。\n`;
        setIsValidationError(true);
      }
      if ((formRef.paypayName.current === null || formRef.paypayName.current === "") && (inputValue.paypayName === null || inputValue.paypayName === "")) {
        errorMessage += `PayPay名を入力してください。\n`;
        setIsValidationError(true);
      }
      if ((formRef.paypayId.current === null || formRef.paypayId.current === "") && (inputValue.paypayId === null || inputValue.paypayId === "")) {
        errorMessage += `PayPayIDまたは電話番号を入力してください。\n`;
        setIsValidationError(true);
      }
      if (questionValue.questionContent !== null && questionValue.questionContent !== "") {
        if ((formRef.questionAnswer.current === null || formRef.questionAnswer.current === "") && (questionValue.questionAnswer === null || questionValue.questionAnswer === "")) {
          errorMessage += `質問の回答を入力してください。\n`;
          setIsValidationError(true);
        }
      }
      if (!eventInfo.isSoldOut || inputValue?.reserveStatus?.isCancelWaitReserveNotified()) {
        if (!formRef.isPayComplete.current) {
          errorMessage = `支払い完了後に予約申請をお願いします。`;
          setIsValidationError(true);
        }
      }
    }
    setValidationErrorMessage(errorMessage);

    // バリデーションエラーがなければ、確認ダイアログを表示する
    if (errorMessage === "") {
      setIsValidationError(false);
      setOpenApplyDialog(true);
    }
  };

  /**
   * 予約申請確認ダイアログ「はい」ボタン処理
   */
  const handleConfirm = () => {
    // リクエストボディを作成
    const requestData = {
      user_id : userId,
      event_id : eventId,
      reserve_cls : formRef.reserveCls.current === inputValue.reserveCls ? null : formRef.reserveCls.current,
      b_participation_flag : "0",
      d_participation_flag : "0",
      sex : formRef.sex.current === inputValue.sex ? null : formRef.sex.current,
      birthday : formRef.birthday.current === inputValue.birthday ? null : formRef.birthday.current,
      paypay_name : formRef.paypayName.current === inputValue.paypayName ? null : formRef.paypayName.current,
      paypay_id : formRef.paypayId.current === inputValue.paypayId ? null : formRef.paypayId.current,
      question_answer : formRef.questionAnswer.current === inputValue.questionAnswer ? null : formRef.questionAnswer.current,
      message : formRef.message.current === inputValue.message ? null : formRef.message.current
    };

    // 改行コードを統一（バックエンド側でエスケープするため、ここでは統一のみ）
    requestData.message =  requestData.message ? requestData.message.replace(/\r\n|\r/g, "\n") : null;
    requestData.question_answer =  requestData.question_answer ? requestData.question_answer.replace(/\r\n|\r/g, "\n") : null;

    // バスケ・飲み会参加フラグを予約内容から演繹
    requestData.b_participation_flag = requestData.reserve_cls === "1" ? "1" : requestData.reserve_cls === "2" ? "1" : "0";
    requestData.d_participation_flag = requestData.reserve_cls === "2" ? "1" : requestData.reserve_cls === "3" ? "1" : "0";

    // 予約処理を実行
    reserveApply(requestData).then(response => {
      if (response.status !== 200) {
        // 予約失敗ダイアログを表示
        setConfirmationMessage(
          '予約申請が失敗しました。再度予約申請をお試し下さい。エラーメッセージ：'
          + response.data.message
        );
        setOpenApplyConfirmFailedDialog(true);
        setOpenApplyDialog(false);
      } else {
        // 予約完了ダイアログを表示
        setConfirmationMessage(
          '予約申請が完了しました。承認されると参加可能となります。承認までお待ちください。'
        );
        setOpenApplyConfirmDialog(true);
        setOpenApplyDialog(false);
      }
    })   
  };

  // ======================================
  // 「キャンセル申請」関連処理
  // ======================================
  /**
   * 「キャンセル」ボタン処理
   */
  const handleOnCancelClick = () => {
    // バリデーションチェック処理
    let errorMessage = ``;
    if ((userId === null || userId === "") || (eventId === null || eventId === "")) {
      errorMessage += `ユーザーIDまたはイベントIDが確認できません。イベント一覧画面からやり直してください。`;
      setIsValidationError(true);
      setValidationErrorMessage(errorMessage);
    }

    // バリデーションエラーがなければ、確認ダイアログを表示する
    if (errorMessage === "") {
      setIsValidationError(false);
      setOpenCancelDialog(true);
    }
  };

  /**
   * キャンセル確認ダイアログ「はい」ボタン処理
   * キャンセル処理
   */
  const handleConfirmCancel = () => {
    if (!cancelTarget) {
      // キャンセル枠が選択されていない場合、警告を出して処理終了
      setShowCancelValidationMessage(true);
      return;
    }

    // キャンセル処理を実行
    setShowCancelValidationMessage(false);
    cancelApply(userId, eventId, cancelTarget).then(response => {
      if (response.status !== 200) {
        // キャンセル失敗ダイアログを表示
        setConfirmationMessage(
          'キャンセル申請が失敗しました。再度キャンセル申請をお試し下さい。エラーメッセージ：'
          + response.data.message
        );
        setOpenCancelConfirmFailedDialog(true);
      } else {
        // キャンセル完了ダイアログを表示
        setConfirmationMessage(
          'キャンセル申請が完了しました。支払い済の場合は返金対応致しますので今しばらくお待ちください。'
        );
        setOpenCancelConfirmDialog(true);
      }
    })
    setOpenCancelDialog(false);
  };

  /**
   * 飲み会当日参加ボタン
   */
  const handleTodayApply = () => {
    // 飲み会当日参加申請処理
    todayDrinkApply(userId, eventId).then(response => {
      setProcessResultMessage(response.message);
      setOpenResultDialog(true);
    })
    setOpentodayApplyDialog(false);
  };

  /**
   * ラジオボタン変更時の処理
   */
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCancelTarget(event.target.value);
  };

  // ======================================
  // ダイアログ共通処理
  // ======================================
  /**
   * 【ダイアログ共通】
   * 確認ダイアログ「閉じる」ボタン処理
   */
  const handleClose = () => {
    setOpenApplyDialog(false);
    setOpenCancelDialog(false);
  };

  /**
   * 【ダイアログ共通】
   * 申請完了ダイアログ「閉じる」ボタン処理
   */
  const handleCloseConfirmDialog = (isPageTransition: boolean) => {
    setOpenApplyConfirmDialog(false);
    setOpenApplyConfirmFailedDialog(false);
    setOpenCancelConfirmDialog(false);
    setOpenCancelConfirmFailedDialog(false);
    if (isPageTransition) {
      // イベント一覧画面へ遷移する
      const params = {
        "user_id": userId
      }
      navigate("/portal", { state: params });
    }
  };

  // ======================================
  // 画面部品
  // ======================================
  return (
    <>
    {/* イベント一覧へ戻る */}
    <Box sx={{ paddingTop: '10vh' }}>
      <Button
        variant="outlined"
        color="warning"
        startIcon={<ArrowBackIcon sx={{transition: 'transform 0.3s ease'}} />}
        onClick={() => {userId ? navigate("/portal", { state: { user_id: userId } }) : navigate("/login");}}
        sx={{
            ':hover': {
                backgroundColor: '#ff9800',
                color: 'white'
            }
        }}
      >
        戻る
      </Button>
    </Box>
    <form className="eventForm">
      {/* イベント詳細テーブル&入力フォーム */}
      <TableContainer
        sx={{
          margin: "0 auto", // 自動でセンタリング
          width: isMobile ? "100%" : "70%",    // スマホのみ幅を100%に設定
          maxWidth: "100%", // 最大幅を100%に設定
          paddingTop: "10vh",
          boxSizing: "border-box", // パディングを含む全体幅を調整
          overflowX: "hidden", // 横スクロールを防止
        }}
      >
      <Table>
          <TableBody>
            {/* イベントのイメージ画像 */}
            <Box sx={{ my: 2, textAlign: "center" }}>
              <img
                alt="イベントイメージ"
                src={eventInfo.d_eventTime ? otherImage : basketballImage}
                style={{
                  maxWidth: "80%", // スマホ画面にフィットさせる
                  height: "auto",
                }}
              />
            </Box>

            {/* イベント詳細部分 */}
            <TableRow>
              <TableCell colSpan={2} sx={{ border: "none", boxShadow: "none" }}>
                <EventInfo eventInfo={eventInfo} />
              </TableCell>
            </TableRow>

            {/* 予約内容入力フォーム部分 */}
            <TableRow>
              <TableCell colSpan={2} sx={{ border: "none", boxShadow: "none" }}>
                <InputFormat inputValue={inputValue} formRef={formRef} />
              </TableCell>
            </TableRow>

            {/* 質問部分 */}
            <TableRow>
              <TableCell colSpan={2} sx={{ border: "none", boxShadow: "none" }}>
                <QuestionAnswer questionValue={questionValue} formRef={formRef} />
              </TableCell>
            </TableRow>

            {/* 支払い確認部分 */}
            <TableRow>
              <TableCell
                colSpan={2}
                sx={{
                  border: "none",
                  boxShadow: "none",
                  display: inputValue?.reserveStatus?.isReserved() ? (inputValue?.reserveStatus?.isCancelWaitReserveNotified() ? "flex" : "none") : (eventInfo?.isSoldOut ? "none" : (isToday ? "none" : "flex")),
                }}
              >
                <PayCompleteConfirm isPayCompleteRef={formRef.isPayComplete} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* ボタン部分 */}
      <TableContainer
        sx={{
          margin: "5% auto",
          maxWidth: isMobile ? "80%" : "30%"
        }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell
                  colSpan={2}
                  align="center"
                  sx={{
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  {/* バリデーションエラーメッセージ */}
                  <Typography
                    sx={{
                      display: isValidationError ? "flex" : "none",
                      alignItems: "center",
                      textAlign: "left",
                      color: "#fff",
                      backgroundColor: "#f44336",
                      padding: "10px",
                      borderRadius: "5px",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    <ErrorIcon sx={{ marginRight: "8px" }} />
                    {validationErrorMessage}
                  </Typography>
                  {inputValue?.reserveStatus?.isNotShowButton() ? (
                    /* ボタン表示しないパターン */
                    <>
                      <Typography
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          textAlign: 'left',
                          color: '#fff',
                          backgroundColor: '#FF9800',
                          padding: '10px',
                          borderRadius: '5px',
                        }}
                      >
                        <WarningAmberIcon sx={{ marginRight: '8px' }} /> 
                        イベント当日のキャンセル・予約操作は実施できません。ご希望の場合は公式LINEよりお問合せ下さい！
                      </Typography>
                      {inputValue?.reserveStatus?.isCancelApprovalWait() ? (
                        <>
                          <Button variant="contained" color="primary" disabled sx={{ padding: "12px", borderRadius: "8px", margin: "16px 0", fontSize: { xs: "16px", sm: "20px" }, width: "100%" }}>
                            キャンセル承認待ち
                          </Button>
                        </>
                      ) : (<></>)}
                    </>
                  ) : (
                    /* ボタンを表示するパターン */
                    <>
                      {isToday ? (
                        /* 飲み会当日参加ボタン */
                        <>
                          {eventInfo?.d_eventTime && (!inputValue?.dParticipationFlag || inputValue?.dParticipationFlag === "0") && inputValue?.reserveStatus?.isConfirm() ? (
                            <>
                              <Button
                                variant="contained"
                                color="success"
                                onClick={() => setOpentodayApplyDialog(true)}
                                sx={{ padding: "12px 24px", borderRadius: "8px", margin: "16px 0", fontSize: { xs: "16px", sm: "20px" }, width: "100%" }}
                              >
                                飲み会当日参加
                              </Button>
                            </>
                          ) : (
                            <>
                              {/* キャンセル待ち予約中_通知済の場合 */}
                              {inputValue?.reserveStatus?.isCancelWaitReserveNotified() ? (
                                <>
                                  <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleOnReserveClick}
                                    sx={{ padding: "12px 24px", borderRadius: "8px", margin: "16px 0", fontSize: { xs: "16px", sm: "20px" }, width: "100%" }}
                                  >
                                    参加する
                                  </Button>
                                  <Button
                                    variant="contained"
                                    color={"error"}
                                    onClick={handleOnCancelClick}
                                    sx={{ padding: "12px 24px", borderRadius: "8px", margin: "16px 0", fontSize: { xs: "16px", sm: "20px" }, width: "100%" }}
                                  >
                                    キャンセル待ちをやめる
                                  </Button>
                                </>
                              ) : (<></>)}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {/* キャンセル待ち予約中_通知済の場合 */}
                          {inputValue?.reserveStatus?.isCancelWaitReserveNotified() ? (
                            <>
                              <Button
                                variant="contained"
                                color="success"
                                onClick={handleOnReserveClick}
                                sx={{ padding: "12px 24px", borderRadius: "8px", margin: "16px 0", fontSize: { xs: "16px", sm: "20px" }, width: "100%" }}
                              >
                                参加する
                              </Button>
                            </>
                          ) : (<></>)}
                          {inputValue?.reserveStatus?.isCancelButtonDisplay() ? (
                            // キャンセル申請ボタン
                            <Button
                              variant="contained"
                              color={"error"}
                              onClick={handleOnCancelClick}
                              sx={{ padding: "12px 24px", borderRadius: "8px", margin: "16px 0", fontSize: { xs: "16px", sm: "20px" }, width: "100%" }}
                            >
                              {(inputValue?.reserveStatus?.isCancelWaitReserve() || inputValue?.reserveStatus?.isCancelWaitReserveNotified()) ? "キャンセル待ちをやめる" : "キャンセル申請"}
                            </Button>
                          ) : (
                            // 予約申請ボタン
                            <Button
                              variant="contained"
                              color="success"
                              onClick={handleOnReserveClick}
                              sx={{ padding: "12px 24px", borderRadius: "8px", margin: "16px 0", fontSize: { xs: "16px", sm: "20px" }, width: "100%" }}
                            >
                              {eventInfo?.isSoldOut ? "キャンセル待ち予約" : "予約申請"}
                            </Button>
                          )}
                        </>
                      )}
                    </>
                  )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* よくある質問インフォメーション部分 */}
      <FaqInformationBox />

      {/* キャンセル確認ダイアログ */}
      <Dialog open={openCancelDialog} onClose={handleClose}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'warning.main',
            }}
          >
            <WarningAmberIcon fontSize="large" />
            <Typography variant="h6">確認</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              marginBottom: 2,
            }}
          >
            キャンセル申請をします。以下のうちからキャンセルする対象を選択してください。
          </Typography>
          {/* ラジオボタンでキャンセル対象を選択 */}
          <RadioGroup
            value={cancelTarget}
            onChange={handleRadioChange}
          >
            {inputValue.reserveCls === "1" || inputValue.reserveCls === "2" ? (<FormControlLabel value="10" control={<Radio />} label="バスケをキャンセル" />) : (<></>)}
            {inputValue.reserveCls === "3" || inputValue.reserveCls === "2" ? (<FormControlLabel value="20" control={<Radio />} label="飲み会をキャンセル" />) : (<></>)}
            {inputValue.reserveCls === "2" ? (<FormControlLabel value="30" control={<Radio />} label="バスケ&飲み会を両方キャンセル" />) : (<></>) }
          </RadioGroup>
          {/* バリデーションエラーメッセージ */}
          <Box
            sx={{
              display: showCancelValidationMessage ? "flex" : "none",
              alignItems: "center",
              textAlign: "left",
              color: "#fff",
              backgroundColor: "#f44336",
              padding: "10px",
              borderRadius: "5px",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            <ErrorIcon sx={{ marginRight: "8px" }} />
            <Typography>
              キャンセルしたい枠を選択してください。
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="error"
          >
            いいえ
          </Button>
          <Button
            onClick={handleConfirmCancel}
            variant="contained"
            color="success"
          >
            はい
          </Button>
        </DialogActions>
      </Dialog>

      {/* キャンセル申請完了通知ダイアログ */}
      <Dialog open={openCancelConfirmDialog} onClick={() => handleCloseConfirmDialog(true)}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'success.main',
            }}
          >
            <CheckCircleOutlineIcon fontSize="large" />
            <Typography variant="h6">キャンセル申請完了</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              marginBottom: 1,
            }}
          >
            {confirmationMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleCloseConfirmDialog(true)}
            variant="contained"
            color="success"
            sx={{ borderRadius: '8px' }}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>

      {/* キャンセル申請失敗通知ダイアログ */}
      <Dialog open={openCancelConfirmFailedDialog} onClick={() => handleCloseConfirmDialog(false)}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'error.main',
            }}
          >
            <CheckCircleOutlineIcon fontSize="large" />
            <Typography variant="h6">キャンセル申請失敗</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              marginBottom: 1,
            }}
          >
            {confirmationMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleCloseConfirmDialog(false)}
            variant="contained"
            color="error"
            sx={{ borderRadius: '8px' }}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>

      {/* 予約申請確認ダイアログ */}
      <Dialog open={openApplyDialog} onClose={handleClose}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'warning.main',
            }}
          >
            <WarningAmberIcon fontSize="large" />
            <Typography variant="h6">確認</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              marginBottom: 1,
            }}
          >
            {eventInfo?.isSoldOut ? (eventInfo?.reserveStatus?.isCancelWaitReserveNotified() ? "参加を申請します。参加費は支払い済でしょうか？（PayPayID：suzukikzy714まで支払いお願いします）" : "キャンセル待ち予約します。よろしいでしょうか？") : "予約申請をします。参加費は支払い済でしょうか？（PayPayID：suzukikzy714まで支払いお願いします）"}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'error.main',
              fontWeight: 'bold',
            }}
          >
            {eventInfo?.isSoldOut ? (eventInfo?.reserveStatus?.isCancelWaitReserveNotified() ? "未払いの場合、予約申請は却下されます" : "参加可能になるまで参加費は支払わないでください。参加可能となった場合はLINEでご案内致します。") : "未払いの場合、予約申請は却下されます"}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              marginBottom: 1,
            }}
          >
            {eventInfo?.isSoldOut ? (eventInfo?.reserveStatus?.isCancelWaitReserveNotified() ? "※前日23:59までのキャンセルは100%返金、当日0:00以降のキャンセルは返金不可となります。" : "") : "※前日23:59までのキャンセルは100%返金、当日0:00以降のキャンセルは返金不可となります。"}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="error"
          >
            いいえ
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="success"
          >
            はい
          </Button>
        </DialogActions>
      </Dialog>

      {/* 予約完了通知ダイアログ */}
      <Dialog open={openApplyConfirmDialog} onClick={() => handleCloseConfirmDialog(true)}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'success.main',
            }}
          >
            <CheckCircleOutlineIcon fontSize="large" />
            <Typography variant="h6">予約申請完了</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              marginBottom: 1,
            }}
          >
            {confirmationMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleCloseConfirmDialog(true)}
            variant="contained"
            color="success"
            sx={{ borderRadius: '8px' }}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>

      {/* 予約失敗通知ダイアログ */}
      <Dialog open={openApplyConfirmFailedDialog} onClick={() => handleCloseConfirmDialog(false)}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'error.main',
            }}
          >
            <CheckCircleOutlineIcon fontSize="large" />
            <Typography variant="h6">予約申請失敗</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              marginBottom: 1,
            }}
          >
            {confirmationMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleCloseConfirmDialog(false)}
            variant="contained"
            color="error"
            sx={{ borderRadius: '8px' }}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>

      {/* 飲み会当日参加確認ダイアログ */}
      <Dialog open={opentodayApplyDialog} onClose={() => setOpentodayApplyDialog(false)}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'warning.main',
            }}
          >
            <WarningAmberIcon fontSize="large" />
            <Typography variant="h6">確認</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
          >
            飲み会当日参加を申請します。よろしいですか？
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpentodayApplyDialog(false)}
            variant="outlined"
            color="error"
          >
            いいえ
          </Button>
          <Button
            onClick={handleTodayApply}
            variant="contained"
            color="success"
          >
            はい
          </Button>
        </DialogActions>
      </Dialog>
    </form>

    {/* 処理結果通知ダイアログ */}
    <Dialog open={openResultDialog} onClose={() => setOpenResultDialog(false)}>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'primary.main',
            }}
          >
            <InfoIcon fontSize="large" />
            <Typography variant="h6">処理結果</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <pre>{processResultMessage}</pre>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setOpenResultDialog(false);navigate("/mng/portal", { state: { user_id: userId } })}} variant="outlined" color="error">
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
